import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import {
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import SelectDepartamentosItem from "../../../../Components/SelectDepartamentosItem";
import SelectPuestosItem from "../../../../Components/SelectPuestosItem";
import reporteEmpleadosPdf from "../../../../Pdf/reporteEmpleadosPdf";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

const getEstadoTexto = (estadoNum) => (estadoNum === 1 ? "Activo" : "Inactivo");

class ReporteEmpleados extends Component {
  state = {
    loading: false,
    dataReporte: null,
    todosEmpleados: [],
  };

  atras() {
    this.props.history.goBack();
  }

  componentDidMount() {
    this.consultarReporteEmpleados({
      departamentos: [],
      puestos: [],
      estado: 3,
      periodo: null,
    });
  }

  consultarReporteEmpleados(values) {
    this.setState({ loading: true });
    const { periodo, ...resto } = values;
    axios
      .post(
        "reportesRecursosHumanos/reporteEmpleados",
        {
          ...resto,
          fechaInicio: periodo && periodo[0] ? periodo[0] : null,
          fechaFin: periodo && periodo[1] ? periodo[1] : null,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todosEmpleados: res.data.empleados,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        message.error("Error de conexión: " + err.message);
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const datosDescargar = this.state.todosEmpleados.map((empleado) => ({
      Numero: empleado.serieNumero,
      Nombre: empleado.nombre,
      RFC: empleado.rfc,
      CURP: empleado.curp,
      Correo: empleado.correoElectronico,
      "Fecha Nacimiento": empleado.fechaNacimiento
        ? moment(empleado.fechaNacimiento).format("DD/MM/YYYY")
        : "",
      Sexo: empleado.sexo,
      Departamento: empleado.departamento,
      Puesto: empleado.puesto,
      "Fecha Alta": empleado.fechaAlta
        ? moment(empleado.fechaAlta).format("DD/MM/YYYY")
        : "",
      "Fecha Baja": empleado.fechaBaja
        ? moment(empleado.fechaBaja).format("DD/MM/YYYY")
        : "",
      "Salario Diario": empleado.salarioDiario,
      NSS: empleado.numSeguridadSocial,
      Estado: getEstadoTexto(empleado.estado),
    }));

    const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Empleados");
    XLSX.writeFile(workbook, "Reporte_Empleados.xlsx");
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteEmpleadosPdf(this.state.dataReporte))
      .download("Reporte_Empleados.pdf");
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Numero",
        dataIndex: "serieNumero",
        key: "serieNumero",
        sorter: (a, b) => (a.numero || 0) - (b.numero || 0),
        buscar: "serieNumero",
        ellipsis: true,
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => (a.nombre || "").localeCompare(b.nombre || ""),
        buscar: "nombre",
        ellipsis: true,
      },
      {
        title: "RFC",
        dataIndex: "rfc",
        key: "rfc",
        buscar: "rfc",
        ellipsis: true,
      },
      {
        title: "Correo",
        dataIndex: "correoElectronico",
        key: "correoElectronico",
        ellipsis: true,
      },
      {
        title: "Departamento",
        dataIndex: "departamento",
        key: "departamento",
        sorter: (a, b) => (a.departamento || "").localeCompare(b.departamento || ""),
        buscar: "departamento",
        ellipsis: true,
      },
      {
        title: "Puesto",
        dataIndex: "puesto",
        key: "puesto",
        sorter: (a, b) => (a.puesto || "").localeCompare(b.puesto || ""),
        buscar: "puesto",
        ellipsis: true,
      },
      {
        title: "Fecha Alta",
        dataIndex: "fechaAlta",
        key: "fechaAlta",
        sorter: (a, b) => moment(a.fechaAlta).unix() - moment(b.fechaAlta).unix(),
        ellipsis: true,
        render: (fecha) => (fecha ? moment(fecha).format("DD/MM/YYYY") : "N/A"),
      },
      {
        title: "Salario Diario",
        dataIndex: "salarioDiario",
        key: "salarioDiario",
        align: "right",
        ellipsis: true,
      },
      {
        title: "NSS",
        dataIndex: "numSeguridadSocial",
        key: "numSeguridadSocial",
        ellipsis: true,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => a.estado - b.estado,
        ellipsis: true,
        render: (estado) => getEstadoTexto(estado),
      },
    ];

    return (
      <>
        <Form
          name="reporteEmpleados"
          onFinish={this.consultarReporteEmpleados.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            departamentos: [],
            puestos: [],
            estado: 3,
            periodo: null,
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte de Empleados"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem type="primary" htmlType="submit">
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 10,
                marginBottom: 10,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row gutter={[16, 0]}>
                <Col span={7}>
                  <FormItem label="Departamentos" name="departamentos">
                    <SelectDepartamentosItem
                      mode="multiple"
                      placeholder="Filtrar por Departamento(s)"
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                    />
                  </FormItem>
                </Col>
                <Col span={7}>
                  <FormItem label="Puestos" name="puestos">
                    <SelectPuestosItem
                      mode="multiple"
                      placeholder="Filtrar por Puesto(s)"
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                    />
                  </FormItem>
                </Col>
                <Col span={5}>
                  <FormItem label="Estado" name="estado">
                    <Select placeholder="Filtrar Por Estado">
                      <Option value={3}>Todos</Option>
                      <Option value={1}>Activo</Option>
                      <Option value={2}>Inactivo</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span={5}>
                  <FormItem label="Fecha Alta" name="periodo">
                    <RangePickerItem />
                  </FormItem>
                </Col>
              </Row>
            </div>

            <TableItem
              rowKey="_id"
              columns={columns}
              dataSource={this.state.todosEmpleados}
              size="small"
              pagination={false}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteEmpleados);
